export const DIRECTORY_SET = 'directory-set';
export const DOCUMENT_SET_CURRENT = 'doucment-set-current';
export const DOCUMENT_UPDATE = 'doucments-update';
export const DOCUMENTS_SET = 'doucments-set';
export const SECURITY_SET_TOKEN = 'security-set-token';
export const SECURITY_SET_USER = 'security-set-user';
export const SECURITY_SET_TARGET_URL = 'security-set-target-url';
export const TAGS_SET = 'tags-set';